import create, { UseBoundStore } from 'zustand';

export interface GlobalStoreType {
  isLandingVisible: boolean;
  setLandingVisible: (state: boolean) => void;

  isCardExpanded: boolean;
  setCardExpanded: (state: boolean) => void;

  isSidebarExpanded: boolean;
  setSidebarExpanded: (state: boolean) => void;

  currentTheme: string | null;
  setCurrentTheme: (index: string | null) => void;

  currentChapter: string | null;
  setCurrentChapter: (index: string | null) => void;

  isWindowTooSmall: boolean;
  setWindowTooSmall: (state: boolean) => void;

  isUnsupportedWindowAspectRatio: boolean;
  setUnsupportedWindowAspectRatio: (state: boolean) => void;

  shouldRotateDevice: boolean;
  setRotateDevice: (state: boolean) => void;

  isError: boolean;
  setError: (state: boolean) => void;

  isSmallDevice: boolean;
  setSmallDevice: (state: boolean) => void;
}

const useGlobalStore: UseBoundStore<GlobalStoreType> = create(
  (
    set: (partial: (store: GlobalStoreType) => Partial<GlobalStoreType>) => void
  ) => {
    return {
      isLandingVisible: true,
      setLandingVisible: state => {
        set(() => ({
          isLandingVisible: state,
        }));
      },

      isCardExpanded: false,
      setCardExpanded: state => {
        set(() => ({
          isCardExpanded: state,
        }));
      },

      isSidebarExpanded: false,
      setSidebarExpanded: state => {
        set(() => ({
          isSidebarExpanded: state,
        }));
      },

      currentTheme: null,
      setCurrentTheme: name => {
        set(() => ({
          currentTheme: name,
          currentChapter: 'introduction',
          isCardExpanded: false,
        }));
      },

      currentChapter: 'introduction',
      setCurrentChapter: name => {
        set(() => ({
          currentChapter: name,
        }));
      },

      isWindowTooSmall: false,
      setWindowTooSmall: state => {
        set(() => ({
          isWindowTooSmall: state,
        }));
      },

      isUnsupportedWindowAspectRatio: true,
      setUnsupportedWindowAspectRatio: state => {
        set(() => ({
          isUnsupportedWindowAspectRatio: state,
        }));
      },

      shouldRotateDevice: false,
      setRotateDevice: state => {
        set(() => ({
          shouldRotateDevice: state,
        }));
      },

      isError: false,
      setError: state => {
        set(() => ({
          isError: state,
        }));
      },

      isSmallDevice: false,
      setSmallDevice: state => {
        set(() => ({
          isSmallDevice: state,
        }));
      },
    };
  }
);

export default useGlobalStore;
